module.exports = __webpack_public_path__ + "static/media/up-arrow-svgrepo-com (7).022058e0.svg";